
import Vue from 'vue'

export default Vue.extend({
  name: 'UiModal',
  props: {
    modalShow: {
      type: Boolean,
      default: false
    },
    modalSize: {
      type: String,
      default: ''
    },
    closeOnClick: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  watch: {
    modalShow (value) {
      this.freezeScroll(value)
    }
  },

  mounted () {
    this.freezeScroll(this.modalShow)
  },

  beforeDestroy () {
    this.freezeScroll(false)
  },

  methods: {
    close (force = false) {
      if (!this.closeOnClick && !force) { return }
      this.$emit('close')
    },

    freezeScroll (value: boolean) {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
      const BODY = document.body

      if (value) {
        BODY.style.marginRight = scrollbarWidth + 'px'
        BODY.style.overflow = 'hidden'
      } else {
        BODY.style.marginRight = 0 + 'px'
        BODY.style.overflow = ''
      }
    }
  }
})
